// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"943aa886","425":"7898d23b","473":"bc3fc8ef","741":"52a0dbec","774":"c0e2ed74","782":"b17b6d46","787":"3996ab0f","883":"30533b46"}[chunkId] + ".chunk.js";
};